function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
import { CalendarWeek, CalendarDay, CalendarMonth } from "../classes/index.js";
/** Return the months to display in the calendar. */
export function getMonths( /** The months (as dates) to display in the calendar. */
displayMonths, /** The dates to display in the calendar. */
dates, /** Options from the props context. */
props, dateLib) {
  var startOfWeek = dateLib.startOfWeek,
    endOfWeek = dateLib.endOfWeek,
    startOfISOWeek = dateLib.startOfISOWeek,
    endOfISOWeek = dateLib.endOfISOWeek,
    endOfMonth = dateLib.endOfMonth,
    addDays = dateLib.addDays,
    getWeek = dateLib.getWeek,
    getISOWeek = dateLib.getISOWeek;
  var dayPickerMonths = displayMonths.reduce(function (months, month) {
    var firstDateOfFirstWeek = props.ISOWeek ? startOfISOWeek(month) : startOfWeek(month, {
      locale: props.locale,
      weekStartsOn: props.weekStartsOn
    });
    var lastDateOfLastWeek = props.ISOWeek ? endOfISOWeek(endOfMonth(month)) : endOfWeek(endOfMonth(month), {
      locale: props.locale,
      weekStartsOn: props.weekStartsOn
    });
    /** The dates to display in the month. */
    var monthDates = dates.filter(function (date) {
      return date >= firstDateOfFirstWeek && date <= lastDateOfLastWeek;
    });
    if (props.fixedWeeks && monthDates.length < 42) {
      var extraDates = dates.filter(function (date) {
        return date > lastDateOfLastWeek && date <= addDays(lastDateOfLastWeek, 7);
      });
      monthDates.push.apply(monthDates, _toConsumableArray(extraDates));
    }
    var weeks = monthDates.reduce(function (weeks, date) {
      var weekNumber = props.ISOWeek ? getISOWeek(date) : getWeek(date, {
        locale: props.locale,
        weekStartsOn: props.weekStartsOn,
        firstWeekContainsDate: props.firstWeekContainsDate
      });
      var week = weeks.find(function (week) {
        return week.weekNumber === weekNumber;
      });
      var day = new CalendarDay(date, month, dateLib);
      if (!week) {
        weeks.push(new CalendarWeek(weekNumber, [day]));
      } else {
        week.days.push(day);
      }
      return weeks;
    }, []);
    var dayPickerMonth = new CalendarMonth(month, weeks);
    months.push(dayPickerMonth);
    return months;
  }, []);
  if (!props.reverseMonths) {
    return dayPickerMonths;
  } else {
    return dayPickerMonths.reverse();
  }
}